<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-too_long_on_status-description') }}
        </p>

        <template v-show="!loading">
            <template v-if="external_status.length > 0">
                <div class="field">
                    <label
                        :class="{
                            label: true,
                            'label-danger': !isFieldValid('filterStatus'),
                        }"
                        >{{ t('automations-form-triggers_config-too_long_on_status-status_label') }}
                    </label>
                    <select v-model="filterStatus" class="form-control">
                        <option
                            v-for="status in external_status"
                            :value="status.id"
                            :key="status.id"
                        >
                            {{ status.external_label }}
                        </option>
                    </select>
                </div>

                <div class="field" v-show="!!filterStatus">
                    <label
                        :class="{
                            label: true,
                            'label-danger': !isFieldValid('filterDays'),
                        }"
                        >{{ t('automations-form-triggers_config-too_long_on_status-days_label') }}</label
                    >
                    <input
                        type="number"
                        v-model="filterDays"
                        class="form-control"
                    />
                </div>

                <div
                    class="field filter-value"
                    v-for="field in fieldsThatCanFilter"
                    :key="field.id"
                >
                    <template v-if="customFieldsFilter[field.id]">
                        <label :class="{ label: true }">
                            <input
                                type="checkbox"
                                v-model="customFieldsFilter[field.id]['enabled']"
                            />
                            {{ t('automations-form-triggers_config-too_long_on_status-filter_orders_label', [field.field_name]) }}</label
                        >

                        <div
                            v-show="customFieldsFilter[field.id]['enabled']"
                            class="row inputs"
                        >
                            <div class="col-5">
                                <select
                                    class="form-control"
                                    v-model="customFieldsFilter[field.id]['filterType']"
                                >
                                    <option value="equals">{{ t('automations-form-triggers_config-too_long_on_status-filter_types-equals') }}</option>
                                    <option value="contains">{{ t('automations-form-triggers_config-too_long_on_status-filter_types-contains') }}</option>
                                    <option value="not_contains">
                                        {{ t('automations-form-triggers_config-too_long_on_status-filter_types-not_contains') }}
                                    </option>
                                    <option value="any_value">
                                        {{ t('automations-form-triggers_config-too_long_on_status-filter_types-any_value') }}
                                    </option>
                                    <option value="no_value">
                                        {{ t('automations-form-triggers_config-too_long_on_status-filter_types-no_value') }}
                                    </option>
                                </select>
                            </div>
                            <div
                                class="col-7"
                                v-if="
                                    ['equals', 'contains', 'not_contains'].includes(
                                        customFieldsFilter[field.id]['filterType'],
                                    )
                                "
                            >
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="customFieldsFilter[field.id]['value']"
                                    :placeholder="t('automations-form-triggers_config-too_long_on_status-value_placeholder')"
                                />
                            </div>
                        </div>
                    </template>
                </div>
                </template>
            <template v-else>
                {{ t('automations-form-triggers_config-too_long_on_status-no_event_help') }}
            </template>
        </template>
    </div>
</template>
<style lang="less">
.filter-value {
    .row.inputs {
        margin-top: 10px;
    }
    input,
    select {
        margin-top: 4px;
    }

    .row.inputs {
        input,
        select {
            margin-top: 0;
        }
    }
}
</style>
<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        let filterDays =
            this.value.length > 0 && this.value[0].filterDays
                ? this.value[0].filterDays
                : "";
        let filterStatus =
            this.value.length > 0 && this.value[0].filterStatus
                ? this.value[0].filterStatus
                : false;

        // Inicialização dos filtros personalizados
        let initialCustomFieldsFilter = {};
        if (this.value.length > 0 && this.value[0].customFieldsFilter) {
            initialCustomFieldsFilter = JSON.parse(JSON.stringify(this.value[0].customFieldsFilter));
        }

        return {
            filterDays: filterDays,
            filterStatus: filterStatus,
            loading: false,
            external_status: [],
            // Novos dados para os campos
            customFieldsFilter: initialCustomFieldsFilter,
            fields: [],
        };
    },
    computed: {
        fieldsThatCanFilter() {
            return this.fields.filter(this.canFilterByField);
        },
        errors() {
            let errors = {};

            if (!this.filterDays) {
                errors["filterDays"] = "empty";
            }

            if (!this.filterStatus) {
                errors["filterStatus"] = "empty";
            }
            return errors;
        },
    },
    mounted: function () {
        window.setTimeout(() => {
            this.changed();
        }, 100);
        this.loadData();
        this.loadFields(); // Carregar campos ao montar
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        loadData() {
            this.loading = true;
            let options = keviApi.getOptions(
                "settings/external-order-status",
                "GET",
            );
            this.$http(options).then((response) => {
                this.loading = false;
                if (response.status === 200) {
                    this.external_status = response.body.status || [];
                }
            });
        },
        // --- Métodos novos para Filtros de Campos ---
        loadFields() {
            let options = keviApi.getOptions("/order-fields", "GET");
            this.$http(options).then((response) => {
                const savedFilters = Object.keys(this.customFieldsFilter).length > 0 
                    ? this.customFieldsFilter 
                    : (this.value.length > 0 && this.value[0].customFieldsFilter ? this.value[0].customFieldsFilter : {});

                let newCustomFieldsFilter = {};

                response.body.forEach((field) => {
                    if (this.canFilterByField(field)) {
                        const savedFilter = savedFilters[field.id];
                        if (savedFilter) {
                             newCustomFieldsFilter[field.id] =
                                this.migrateOrCloneFilter(savedFilter);
                        } else {
                             newCustomFieldsFilter[field.id] =
                                this.getCustomFieldEmptyFilter();
                        }
                    }
                });

                this.customFieldsFilter = newCustomFieldsFilter;
                this.fields = response.body;
            });
        },
        canFilterByField(field) {
            return (
                parseInt(field.show_on_reports) === 1 &&
                ["text"].includes(field.type)
            );
        },
        getCustomFieldEmptyFilter() {
            return {
                enabled: false,
                filterType: "equals",  
                value: "",
            };
        },
        migrateOrCloneFilter(filter) {
            if (filter?.valueEqual !== undefined) {
                let filterType = "equals";
                return {
                    enabled: filter.enabled || false,
                    filterType: filterType,
                    value: filter.valueEqual || "",
                };
            }
             return JSON.parse(JSON.stringify(filter));
        },
        // --------------------------------------------
        isFieldValid(field) {
            return !Object.keys(this.errors).includes(field);
        },
        isValid: function () {
            return Object.keys(this.errors).length === 0;
        },
        changed: function () {
            this.$emit("input", [
                {
                    filterDays: this.filterDays,
                    filterStatus: this.filterStatus,
                    customFieldsFilter: this.customFieldsFilter, // Incluir no output
                },
            ]);
        },
    },
    watch: {
        filterDays: function () {
            this.changed();
        },
        filterStatus: function () {
            this.changed();
        },
        // Watch profundo para os filtros personalizados
        customFieldsFilter: {
            handler: function () {
                this.changed();
            },
            deep: true,
        },
        value: function () {
            let filterDays =
                this.value.length > 0 && this.value[0].filterDays
                    ? this.value[0].filterDays
                    : "";
            let filterStatus =
                this.value.length > 0 && this.value[0].filterStatus
                    ? this.value[0].filterStatus
                    : false;

            if (filterDays !== this.filterDays) {
                this.filterDays = filterDays;
            }

            if (filterStatus !== this.filterStatus) {
                this.filterStatus = filterStatus;
            }

            // Lógica de sincronização para customFieldsFilter (vinda do pai)
            if (
                this.value[0] &&
                this.value[0].customFieldsFilter !== undefined &&
                JSON.stringify(this.value[0].customFieldsFilter) !==
                    JSON.stringify(this.customFieldsFilter)
            ) {
                const propFilters = this.value[0].customFieldsFilter;
                let newLocalFilters = {};

                if (this.fields.length > 0) {
                    this.fields.forEach((field) => {
                        if (this.canFilterByField(field)) {
                            const propFilter = propFilters[field.id];
                            if (propFilter) {
                                newLocalFilters[field.id] =
                                    this.migrateOrCloneFilter(propFilter);
                            } else {
                                newLocalFilters[field.id] =
                                    this.getCustomFieldEmptyFilter();
                            }
                        }
                    });
                    this.customFieldsFilter = newLocalFilters;
                } else {
                    this.customFieldsFilter = JSON.parse(JSON.stringify(propFilters));
                }
            }
        },
    },
};
</script>